import '@fontsource-variable/dm-sans';
import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import './styles.css';

import { MantineProvider } from '@mantine/core';
import { Notifications } from '@mantine/notifications';
import { IconContext } from '@phosphor-icons/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { router } from './App';
import { installGlobalErrorReporting } from './lib/clientErrors';
import { startPrerenderHandoff } from './lib/prerender';
import { queryClient } from './lib/query';
import { theme } from './theme';

installGlobalErrorReporting();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');

startPrerenderHandoff((onPath) => {
  router.subscribe((state) => onPath(state.location.pathname));
});

createRoot(root).render(
  <StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <IconContext.Provider value={{ size: 18, weight: 'regular' }}>
        <Notifications position="top-center" limit={3} />
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </IconContext.Provider>
    </MantineProvider>
  </StrictMode>,
);
